import request from '../../../helpers/request';

const deleteCounterparty = async (id) => {
  await request.delete(
    `/RentPlace/counterparty/${id}`,
    {},
    'При удалении контрагента произошла ошибка'
  );
};

export default deleteCounterparty;
